module.exports = __webpack_public_path__ + "static/media/ticklock.62e09e77.svg";